// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import fastClick from 'fastclick'
import $ from 'jquery'
import "bootstrap"
import "bootstrap/dist/css/bootstrap.css"
import 'animate.css'
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard)

Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.prototype.axios = axios
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })


new Vue({
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')

// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0)
})


// WEBPACK FOOTER //
// ./src/main.js